(function autoCloseDetails() {
  function closeDetails(detailsElement) {
    if (!(detailsElement instanceof HTMLDetailsElement)) return;

    detailsElement.open = false;
    detailsElement.removeAttribute('open');

    var summary = detailsElement.querySelector('summary[aria-expanded]');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  }

  function closeBmPdpDropdown(dropdown) {
    if (!dropdown) return;

    dropdown.classList.remove('is-open');

    var trigger = dropdown.querySelector('.bm-pdp-filter-dd__trigger');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  }

  function closeClosestFacetPanel(target) {
    if (!(target instanceof Element)) return;

    var detailsElement = target.closest(
      'details.facets__panel, sorting-filter-component details'
    );

    if (!(detailsElement instanceof HTMLDetailsElement)) return;

    closeDetails(detailsElement);
  }

  function closeClosestBmPdpDropdown(target) {
    if (!(target instanceof Element)) return;

    var dropdown = target.closest('.bm-pdp-filter-dd');
    if (!dropdown) return;

    window.setTimeout(function () {
      closeBmPdpDropdown(dropdown);
    }, 80);
  }

  document.addEventListener('click', function (event) {
    var detailsToClose = Array.prototype.slice
      .call(document.querySelectorAll('details[data-auto-close-details][open]'))
      .filter(function (element) {
        var closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';

        return (
          element.getAttribute('data-auto-close-details') &&
          element.getAttribute('data-auto-close-details').indexOf(closingOn) !== -1 &&
          event.target instanceof Node &&
          !element.contains(event.target)
        );
      });

    detailsToClose.forEach(function (detailsElement) {
      closeDetails(detailsElement);
    });

    if (!(event.target instanceof Element)) return;

    if (event.target.closest('.bm-filter-close')) {
      closeClosestFacetPanel(event.target);
      return;
    }

    if (event.target.closest('.bm-pdp-filter-dd__option, .bm-pdp-filter-dd__clear')) {
      closeClosestBmPdpDropdown(event.target);
    }
  });
})();